import { Reveal } from "@/components/landing/Reveal";

const PHOTOS = [
  { src: "/images/google/g1.webp", fallback: "/images/google/g1.jpg", caption: "Inside the shop" },
  { src: "/images/google/g6.webp", fallback: "/images/google/g6.jpg", caption: "Racked & ready" },
  { src: "/images/store/gown_green.webp", fallback: "/images/store/gown_green.jpg", caption: "Formal & evening wear" },
  { src: "/images/google/g7.webp", fallback: "/images/google/g7.jpg", caption: "Pressed crisp" },
  { src: "/images/hotel_linen.webp", fallback: "/images/hotel_linen.png", caption: "Hotel & guest linens" },
  { src: "/images/google/g2.webp", fallback: "/images/google/g2.jpg", caption: "Fluffy & fresh" },
  { src: "/images/google/g3.webp", fallback: "/images/google/g3.jpg", caption: "Your neighborhood shop" },
  { src: "/images/google/g4.webp", fallback: "/images/google/g4.jpg", caption: "Right on Ray Rd" },
];

export const Gallery = () => (
  <section data-testid="gallery-section" className="overflow-hidden bg-white py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <Reveal className="mx-auto max-w-2xl text-center">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-blue sm:text-sm">Inside Oxford</p>
        <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-brand-navy sm:text-3xl lg:text-4xl">
          Fresh from the shop
        </h2>
        <p className="mt-4 text-base text-slate-600">
          Real work from our floor to your door — every piece inspected, finished, and hand-delivered.
        </p>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-12 flex snap-x snap-mandatory gap-5 overflow-x-auto pb-4">
          {PHOTOS.map((p, i) => (
            <figure
              key={p.caption}
              data-testid={`gallery-image-${i}`}
              className="group relative w-60 flex-none snap-center overflow-hidden rounded-3xl border border-slate-200 shadow-sm transition-shadow hover:shadow-xl hover:shadow-brand-blue/10 sm:w-64 lg:w-auto"
            >
              <img
                src={p.src}
                onError={p.fallback ? (e) => (e.currentTarget.src = p.fallback) : undefined}
                alt={p.caption}
                loading="lazy"
                decoding="async"
                className="h-72 w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <figcaption className="absolute inset-x-3 bottom-3 rounded-full bg-brand-navy/85 px-4 py-1.5 text-center text-xs font-bold uppercase tracking-widest text-white backdrop-blur">
                {p.caption}
              </figcaption>
            </figure>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
